Bingo.Dashboard = {};
Bingo.Dashboard.init = () => {
    // hide all popovers
    $('.btn-stats, .dropdown-label').click(() => {
        $('.popover').popover('hide');
    });
};
Bingo.Dashboard.clearFilter = () => {
    const $el = $('.js-dashboardFilter');

    const $searchField = $($el).find('.js-textField__searchReset');
    let reloadOfResultsInitialized = false;

    if ($searchField.length > 0) {
        $searchField.trigger('click'); // Reset search field and reload results
        reloadOfResultsInitialized = true;
    }
    $($el).find('.js__filter-input').blur();

    if (reloadOfResultsInitialized) {
        $($el).find('.js__filter-select').data('filter-send-request', 'false'); // Prevent ajax when value change
    }
    $($el).find('.js__filter-select').each((i, el) => {
        const $this = $(el);
        const control = $this[0].selectize;
        if (control !== undefined) {
            const defaultValue = $this.data('filterDefaultValue');
            if (defaultValue !== undefined && defaultValue !== '' && defaultValue !== null) {
                control.setValue($this.data('filterDefaultValue'), false);
            } else {
                control.clear();
            }
        }
    });
    if (reloadOfResultsInitialized) {
        $($el).find('.js__filter-select').data('filter-send-request', 'true'); // Enable ajax on value change again
    }
};
